import React, {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faRotateBackward} from "@fortawesome/free-solid-svg-icons";
import "../styles/status_bar.scss"

export default function StatusBar({
                                    filterList,
                                    search,
                                    setSearch,
                                    searchRef,
                                    tags,
                                    setTags,
                                    hiddenFilters,
                                    setHiddenFilters,
                                    setCurrentPage
                                  }) {

  // As ALL items in FILTER have unique ID, we can map all uri => names...
  let button_tags = [];
  let display_reset = (search?.length > 0 || Object.keys(tags)?.length > 0);

  if (Object.keys(tags)?.length > 0 && filterList) {
    let filter_names = {}; // Here we have an object with all keys => names
    filterList.forEach((filter) => {
      filter_names[filter.uri] = filter.name;
      filter.headings.forEach((subset) => {
        filter_names[subset.uri] = subset.name;
      })
    });
    let tags_keys = Object.keys(tags);
    tags_keys.forEach((tag_uri_key) => {
      button_tags.push({
        parent: [tag_uri_key, filter_names[tag_uri_key]],
        children: [tags[tag_uri_key], filter_names[tags[tag_uri_key]]]
      });
    });
  }
  useEffect(() => {
  }, [tags, search]);

  const RemoveFilter = async (idParentTag) => {
    // Show selectors...
    document.getElementById(idParentTag).classList.remove("disabled", "active");
    // Unset filter...
    let newTags = Object.assign({}, tags)
    delete newTags[idParentTag];
    // Update HIDDEN tags... (remove the chosen one)
    const newHiddenFilters = hiddenFilters.filter(e => e !== idParentTag)
    setHiddenFilters(newHiddenFilters);
    // Finally set TAGs
    setTags(newTags);
    // And restore default pagination to 0
    setCurrentPage(0);
  };

  // For NEW SEARCH Button
  const resetSearch = () => {
    setCurrentPage(0);
    setSearch(null);
    setTags({});
    setHiddenFilters([]);
    searchRef.current.value = null
  };
  
  return (
    <div className="status-bar">
      <div className="key_and_reset">
        {search?.length > 0 && (
          <div><p><span>Cercant document(s) que continguin: <strong>"{search}"</strong></span></p></div>
        )}
        {display_reset && (
          <div className="reset_search" key="reset_search" onClick={(e) => resetSearch()}><FontAwesomeIcon
            icon={faRotateBackward} size="lg"/> <span>Nova cerca</span></div>
        )}
      </div>

      {Object.keys(tags)?.length > 0 && (
        <div className="tags_buttons_container">
          <div className="label"><strong>Filtrat per:</strong></div>
          {button_tags.map(function (tag_set, i) {
            return (
              <div className="pairTags" key={i}>
                <span className="parent-tag" key={tag_set.parent[0]}><strong>{tag_set.parent[1]}</strong></span> >>
                <span className="children-tag" key={tag_set.children[0]}>{tag_set.children[1]}</span>
                <span className="remove-filter" key={tag_set.parent[0] + "_" + tag_set.children[0]}
                      onClick={(e) => RemoveFilter(tag_set.parent[0])}><FontAwesomeIcon icon={faCircleXmark} size="lg"/></span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}